import type { LiveListResData } from "@/types/myLiveRoom/myLiveRoom";
import type { PublicRes } from "@/types/publicRes";
import { http } from "@/utils/http";
import { toQueryString, getFingerprint } from "@/utils/live";

/** 获取多米与产品（GET） */
export const getDomeFishProduct = async (params: {
  pageNo?: number;
  pageSize?: number;
  name?: string;
}) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<any, any>(`/product/getDomeFishProduct${query}`);
};
/** 获取当前用户正在直播的sessionId，和对应的房间（GET） */
export const getLiveSessionIdByRoomId = async (params: { roomId?: string }) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<any, any>(`/live/getLiveSessionIdByRoomId${query}`);
};

// /** 分页查询消费记录列表 */
export const getConsumptionsPageList = async (data?: any) => {
  const params = data ? `?${toQueryString(data)}` : "";
  return await http.get<any, any>(`/live/billing/plans/list${params}`);
};
/** 获取用户直播间详情列表（分页） */
export const getLiveRoomList = async (data?: any) => {
  return await http.post<PublicRes<LiveListResData>, any>("/live/index", {
    data
  });
};
/**
 * 获取直播间详情
 * @param data
 * @returns
 */
export const getLiveRoomDetail = async (data?: any) => {
  return await http.post<any, any>("/live/detail", { data });
};
/**
 * 删除直播间
 * @param data
 * @returns
 */
export const deleteLiveRoom = async (data?: any) => {
  return await http.post<any, any>("/live/delete", { data });
};

/** 保存或更新直播间配置 */
export const saveLiveConfig = async (data?: any) => {
  return await http.post<any, any>("/live/config", { data });
};

/** 紧急插播 */
export const insertUrgent = async (data?: any) => {
  return await http.post<any, any>("/live/insertUrgent", {
    data
  });
};

/** 获取外部平台房间号 */
export const getExternalRoomId = async (roomLink: string) => {
  return await http.post<any, any>("/mock/getExternalRoomId", {
    data: { roomLink }
  });
};

/** 模拟提问 */
export const mockAsk = async (data?: any) => {
  return await http.post<any, any>("/mock/ask", {
    data
  });
};

/** 切换产品 */
export const switchProducts = async (data?: any) => {
  return await http.post<any, any>("/live/switch", { data });
};

/** 开始直播 */
export const startProductsLive = async (data?: any) => {
  // 增加设备指纹
  const phoneId = await getFingerprint();
  data = {
    ...data,
    phoneMsg: phoneId
  };
  return await http.post<any, any>("/live/start", {
    data
  });
};

/** 结束直播 */
export const endProductsLive = async (data?: any) => {
  return await http.post<any, any>("/live/end", {
    data
  });
};

/** 删除直播 */
export const deleteProductsLive = async (data?: any) => {
  return await http.post<any, any>("/live/delete", { data });
};

/** 获取用户直播间详情列表（分页） */
// export const getLiveRoom = async (params: {
//   userId?: string;
//   roomId?: string;
//   status?: string;
//   pageNum?: number;
//   pageSize?: number;
// }) => {
//   const query = params ? `?${toQueryString(params)}` : "";
//   return await http.post<any, any>(`/live/index${query}`);
// };

/**
 * 效验已开播直播间设备信息
 */
export const validLiveVisitorId = async (data?: any) => {
  console.log("🚀 ~ validLiveVisitorId ~ data:", data);
  const phoneId = await getFingerprint();
  data = {
    ...data,
    phoneMsg: phoneId
  };
  const response = await http.post<any, any>("/live/validLiveVisitorId", {
    data
  });
  return response.code;
};

/**
 * 获取默认直播间参数
 */
export const getDefaultLiveParams = async () => {
  const response = await http.post<
    PublicRes<{
      roomName: string;
      voiceCode: any;
    }>,
    any
  >("/live/createRoom", {});
  if (response.code == 200) {
    return response.result;
  } else {
    return Promise.reject("获取默认直播间参数失败!!!!");
  }
};

/**
 *体验直播间开始直播
 */
export const startBroadcastTY = async (data?: any) => {
  return await http.post<any, any>("/live/startBroadcastTY", {
    data
  });
};

/**
 * 体验直播间模拟提问
 */
export const mockAskTY = async (data?: any) => {
  return await http.post<any, any>("/mock/askTY", {
    data
  });
};

/**
 * 体验直播间关播
 */
export const endBroadcastTY = async (data?: any) => {
  return await http.post<any, any>("/live/endTY", {
    data
  });
};

/**
 * 获取体验直播间列表
 */
export const getLiveRoomListTY = async (data?: any) => {
  return await http.post<any, any>("/live/findTYRoomList", {
    data
  });
};

/**
 * 获取用户自定义话术接口（直播间调用） 直播间的分组列表的
 */
export const getUserDefinedSpeechScripts = async (params: {
  productId: string;
}) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<any, any>(
    "/live-room-ai-script/getUserDefinedSpeechScripts" + query
  );
};

/**
 * 批量插入话术
 */
export const batchDiySegments = async (data?: any) => {
  return await http.post<any, any>("/live/batchDiySegments", {
    data
  });
};

/**
 * 批量取消话术
 */
export const batchCancelDiySegments = async (data?: any) => {
  return await http.post<any, any>("/live/batchCancelSegments", {
    data
  });
};

/**
 * 直播间切换策略
 */
export const changeLiveStrategy = async (data?: any) => {
  return await http.post<any, any>("/live/strategy/change", {
    data
  });
};

/**
 * 简易话术分组查询
 */
export const getIsSimpleSpeechScripts = async (params?: any) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<any, any>(
    "/live-room-ai-script/getIsSimpleSpeechScripts" + query
  );
};

/**
 * 获取话术分类key
 */
export const getRepeatKey = async (params?: any) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<any, any>("/live-speech-scripts/getRepeatKey" + query);
};

/**
 * 新增用户自定义话术
 */
export const addSpeechScriptsByVo = async (data?: any) => {
  return await http.post<any, any>(
    "/speech-template-simple/addSpeechScriptsByVo",
    {
      data
    }
  );
};
/**
 * 删除用户自定义话术
 */
export const deleteSpeechScripts = async (id: number | string) => {
  return await http.post<any, any>(
    "/live-speech-scripts/deleteSpeechScripts/" + id
  );
};

/**
 * 更新用户自定义话术
 */
export const editSpeechScripts = async (data?: any) => {
  return await http.post<any, any>("/live-speech-scripts/editSpeechScripts", {
    data
  });
};
/**
 * ai生成话术
 */
export const getUserAiCallLive = async (data?: any) => {
  return await http.post<any, any>("/live-room-ai-script/getUserAiCallLive", {
    data
  });
};

/**
 * 删除分类
 */
export const deleteByGroup = async (key: string | number) => {
  return await http.post<any, any>("/live-room-ai-script/deleteByGroup/" + key);
};

/**
 * 批量翻译
 */
export const translateBatch = async (data?: any) => {
  return await http.post<any, any>("/text/translate", {
    data
  });
};

/**
 * 单次翻译
 */
export const translateSingle = async (data?: any) => {
  return await http.post<any, any>("/text/translate/single", {
    data
  });
};

/**
 * 获取历史语音数据
 */
export const getHistoryVoiceData = async (params?: any) => {
  const query = params ? `?${toQueryString(params)}` : "";
  return await http.get<any, any>(
    "/live-voice-library-history/list-by-product-and-user" + query
  );
};
